<div mat-dialog-content>
  <br/>
  <br/>
  <br/>
  <div fxLayout="column" fxLayoutAlign="center center">
    <div>
      <app-loading [type]="9" [size]="'40px'"></app-loading>
    </div>
    @if (showProgress) {
      <div style="margin: 20px; opacity: 1; color: #ffffff;" fxFlex fxLayoutAlign="center center">
        <mat-icon style="margin-right: 10px;">file_download</mat-icon>
        <span>{{ downloadingItem }}</span>
      </div>
    }
    @if (showCancel) {
      <button mat-mini-fab color="primary" (click)="closeImporting()" class="fade-in">
        <mat-icon style="transform: scale(1.5);">close</mat-icon>
      </button>
    }
  </div>
  <br/>
  <br/>
</div>
